import React from "react";

export const UILogo = (props) => {
    return(
        <span style={{cursor: 'pointer'}} onClick={()=>{
            props.history.push('/');
        }}>BESTDCI</span>
    )
}